export type AdminProgramMode = 'bb' | 'llttf';

export const ADMIN_PROGRAM_MODE_KEY = 'adminProgramMode';

export const BB_ROLE_IDS: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 13, 15];
export const LLTTF_ROLE_IDS: number[] = [9, 10, 11, 12, 14];

export const BB_PROGRAM_IDS: number[] = [1, 2, 3, 4];
export const LLTTF_PROGRAM_IDS: number[] = [5, 6, 7];
/** BounceBack course filters still include LLTTF Adult-Materials (id 7). */
export const BB_COURSE_PROGRAM_IDS: number[] = [1, 2, 3, 4, 7];

export function isBbProgramMode(mode: AdminProgramMode | null | undefined): boolean {
  return mode !== 'llttf';
}
